import {atom, useRecoilState} from "recoil";
import {useCallback} from "react";

export interface BlogData {
    id: number;
    link: string;
    title: string;
    description: string;
    contentUrl: string;
    date: number;
    nickName: string;
}

export const blogsData = atom<BlogData[]>({
    key: 'blogsData',
    default: [],
});

export interface LocalData {
    "ru": string;
    "en": string;
}

export interface VideoData {
    name: LocalData;
    url: LocalData;
}

export interface VideoBlockData {
    name: LocalData;
    content: [VideoData];
}

export const videosData = atom<VideoBlockData[]>({
    key: 'videosData',
    default: [],
});

export interface NewsData {
    id: number;
    title: LocalData;
    description: LocalData;
    date: number;
}

export const newsData = atom<NewsData[]>({
    key: 'newsData',
    default: [],
});

export const useData = () => {
    const [blogsDataV, setBlogData] = useRecoilState(blogsData);
    const updateBlogs = useCallback(() => {
        if (blogsDataV.length > 0)
            return;
        // return Promise.resolve(blogsDataV);
        fetch('/blog/data.json')
            .then(response => {
                if (!response.ok)
                    throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                let dataV = data as BlogData[];
                dataV.sort((a, b) => b.date - a.date/*b.date.localeCompare(a.date)*/);
                setBlogData(dataV);
                return dataV;
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [blogsDataV, setBlogData]);

    const [videosDataV, setVideoData] = useRecoilState(videosData);
    const updateVideos = useCallback(() => {
        if (videosDataV.length > 0)
            return;
        // return Promise.resolve(blogsDataV);
        fetch('/video/data.json')
            .then(response => {
                if (!response.ok)
                    throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                let dataV = data as VideoBlockData[];
                // dataV.sort((a, b) => b.date - a.date/*b.date.localeCompare(a.date)*/);
                setVideoData(dataV);
                return dataV;
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [videosDataV, setVideoData]);

    const [newsDataV, setNewsData] = useRecoilState(newsData);
    const updateNews = useCallback(() => {
        if (newsDataV.length > 0)
            return;
        // return Promise.resolve(blogsDataV);
        fetch('/news/data.json')
            .then(response => {
                if (!response.ok)
                    throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                let dataV = data as NewsData[];
                // dataV.sort((a, b) => b.date - a.date/*b.date.localeCompare(a.date)*/);
                setNewsData(dataV);
                return dataV;
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [newsDataV, setNewsData]);

    return [updateBlogs, updateVideos, updateNews];
};
